import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApartmentSelectComponent } from 'src/app/pages/apartment-select/apartment-select.component';
import { ConfiguratorComponent } from 'src/app/pages/configurator/configurator.component';
import { SuccessComponent } from 'src/app/pages/configurator/success/success.component';
import { HomeComponent } from 'src/app/pages/home/home.component';
import { SegmentsComponent } from 'src/app/pages/segments/segments.component';


const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'selecionar-apartamento', component: ApartmentSelectComponent}, // Versão Apartamentos
  //{path: 'selecionar-lote', component: ApartmentSelectComponent}, // Versão Loteamentos
  {path: 'selecionar-segmento', component: SegmentsComponent},
  {path: 'decorar-apartamento/:codigoUrl', component: ConfiguratorComponent},
  {path: 'decorar-apartamento/sucesso/:codigoUrl', component: SuccessComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    initialNavigation: 'enabled',
    anchorScrolling: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
